module.exports = __webpack_public_path__ + "static/media/bg.d4ae5982.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg.jpg
// module id = 726
// module chunks = 0